<template>
  <v-text-field
    v-model="search"
    :dense="windowWidth < 960"
    :disabled="loading"
    label="Rechercher"
    append-icon="mdi-magnify"
    clearable
    @keyup.enter.native="refresh"
    @click:append="refresh"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState(['loading']),
    search: {
      set (val) { this.$store.state.search = val },
      get () { return this.$store.state.search }
    }
  },
  methods: {
    ...mapActions(['refresh'])
  }
}
</script>
